import { render } from "./videody.vue?vue&type=template&id=6073ab37"
import script from "./videody.vue?vue&type=script&lang=js"
export * from "./videody.vue?vue&type=script&lang=js"

import "./videody.vue?vue&type=style&index=0&id=6073ab37&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__